/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown>, sms: NonNullable<unknown> }} Geliver_Tracking_Status_UpdatedInputs */

const tr_geliver_tracking_status_updated = /** @type {(inputs: Geliver_Tracking_Status_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Güncellendi → ${i?.status}${i?.sms}`)
};

const en_geliver_tracking_status_updated = /** @type {(inputs: Geliver_Tracking_Status_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated → ${i?.status}${i?.sms}`)
};

const de_geliver_tracking_status_updated = /** @type {(inputs: Geliver_Tracking_Status_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisiert → ${i?.status}${i?.sms}`)
};

const ru_geliver_tracking_status_updated = /** @type {(inputs: Geliver_Tracking_Status_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обновлено → ${i?.status}${i?.sms}`)
};

/**
* | output |
* | --- |
* | "Updated → {status}{sms}" |
*
* @param {Geliver_Tracking_Status_UpdatedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_status_updated = /** @type {((inputs: Geliver_Tracking_Status_UpdatedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Status_UpdatedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_status_updated(inputs)
	if (locale === "de") return de_geliver_tracking_status_updated(inputs)
	if (locale === "ru") return ru_geliver_tracking_status_updated(inputs)
	return tr_geliver_tracking_status_updated(inputs)
});